import React, { ReactNode } from 'react';
import { hideModal } from '@/store/reducers/ui-slice';
import { Dialog, Paper, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useDispatch } from 'react-redux';

interface ModalLayoutProps {
  title?: string;
  children: ReactNode;
  isOpen: boolean;
  bannerImg?: string;
  footer?: ReactNode;
  showCloseButton?: boolean;
  showBackButton?: boolean;
  onClose?: () => void;
  fullscreen?: boolean;
  zIndex?: number | string;
}

export function ModalLayout({ title, onClose, children, isOpen, zIndex }: ModalLayoutProps): React.JSX.Element | null {
  const dispatch = useDispatch();
  const handleClose = (): void => {
    dispatch(hideModal());
    onClose?.();
  };

  return (
    <Dialog onClose={handleClose} open={isOpen} maxWidth="lg" sx={{ zIndex: zIndex || 1700 }}>
      <Paper
        sx={{
          border: '1px solid var(--mui-palette-divider)',
          boxShadow: 'var(--mui-shadows-16)',
          p: 3,
          minWidth: { xs: 'auto', md: 600 },
        }}
      >
        <Stack spacing={3}>
          <Typography variant="h6">{title}</Typography>
          <Stack>{children}</Stack>
        </Stack>
      </Paper>
    </Dialog>
  );
}
